// Relentless Video Block
$(document).ready(function () {
    $('.video-block').on('click', '.video-item', function(e){
        e.preventDefault();
        var $videoId = $(this).data('video');
        var $newVideo = $('.data'+$videoId);
        var $swapContent = $newVideo.html();
        var $swapImage = $newVideo.data('image');

        // set video item insidebar to active
        $('.video-item').removeClass('active');
        $('.autoplaying-video').hide();
        $(this).addClass('active');
        //swap the content on the left
        $('.video-launcher').html($swapContent);
        $('.video-block .promo-image').css('background-image', "url('"+$swapImage+"')");
    });
    // launch the video modal
    $('body').on('click', '.launch-video', function(e){
        e.preventDefault();
        var $videoId = $(this).data('video');
        console.log('videoId: '+ $videoId);
        console.log('showing video with id: '+'#video-modal-'+$videoId);
        $('#video-modal-'+$videoId).modal('show');
    });
    // when the modal is closed, refresh the src attribute so the video stops playing.
    $(".video-modal").on('hidden.bs.modal', function (e) {
        $( ".video-modal iframe" ).each(function() {
          $(this).attr("src", $(this).attr("src"));
        });
    });

    // link entire iconLinks banner
    $('.color-icons .bg-blue').on('click', function () {
      $('.color-icons a.banner-link').css('background', '#222');
    });
});
